import React from "react";

import { RecommendRow, RecruitmentRow, RecruitRow } from "../components/DataRow";
import Navbar from "../components/Navbar";

const Favorite = () => {
  const [list, setList] = React.useState([]);
  const [auth, setAuth] = React.useState(0);
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const _auth = JSON.parse(localStorage.getItem("auth"));
    if (_auth !== null) {
      setAuth(_auth);
      // fetch(`/api/favorite/个人用户/${_auth.id}/`)
      //   .then((res) => res.json())
      //   .then((res) => {
      //     if (res.message) {
      //       alert(res.message);
      //     } else {
      //       setList(res.content);
      //     }
      //   });
      const url = [
        "/api/miscellaneous/favorite",
        "?option=ref_id-and-tag",
        `&id=${_auth.id}`,
        "&tag=个人用户",
      ];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          setList(data);
          setProgress(1);
        });
    }
  }, []);

  React.useEffect(() => {
    if (progress === 1) {
      const lt = [];
      list.forEach((current) => {
        if (current.category === "岗位") lt.push(current.ref_id2);
      });
      if (lt.length === 0) {
        setProgress(2);
        return;
      }
      const url = ["/api/biz/job", "?option=by-id", `&list=${lt.join(",")}`];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          const lf = [];
          list.forEach((current) => {
            if (current.category === "岗位") {
              const r = data.find((element) => element.id === current.ref_id2);
              delete current.id;
              const cat = current.category;
              delete current.category;
              lf.push({
                ...current,
                favorite_category: cat,
                ...r,
              });
            } else lf.push(current);
          });
          setList(lf);
          setProgress(2);
        });
    } else if (progress === 2) {
      const lt = [];
      list.forEach((current) => {
        if (current.category === "校园招聘") lt.push(current.ref_id2);
      });
      if (lt.length === 0) {
        setProgress(3);
        return;
      }
      const url = ["/api/bulletin", "?option=campus-by-id-list", `&id_list=${lt.join(",")}`];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          const lf = [];
          list.forEach((current) => {
            if (current.category === "校园招聘") {
              const r = data.find((element) => element.id === current.ref_id2);
              delete current.id;
              const cat = current.category;
              delete current.category;
              if (r !== undefined) {
                lf.push({
                  ...current,
                  favorite_category: cat,
                  category: cat,
                  name: r.title,
                  id: r.id,
                  uuid: r.uuid,
                  address2: r.address_level2,
                  address3: r.address_level3,
                  date: r.date,
                  enterprise_name: r.school,
                });
              }
            } else lf.push(current);
          });
          setList(lf);
          setProgress(3);
        });
    } else if (progress === 3) {
      const lt = [];
      list.forEach((current) => {
        if (current.category === "推荐信息") lt.push(current.ref_id2);
      });
      if (lt.length === 0) {
        setProgress(4);
        return;
      }
      const url = ["/api/bulletin", "?option=notification-by-id_list", `&id_list=${lt.join(",")}`];
      fetch(url.join(""))
        .then((response) => response.json())
        .then((data) => {
          const lf = [];
          list.forEach((current) => {
            if (current.category === "推荐信息") {
              const r = data.find((element) => element.id === current.ref_id2);
              delete current.id;
              const cat = current.category;
              delete current.category;
              lf.push({
                ...current,
                favorite_category: cat,
                ...r,
              });
            } else lf.push(current);
          });
          setList(lf);
          setProgress(4);
        });
    }
  }, [progress]);

  // -> dataRow
  const dateRow = (item) => {
    let row;
    if (item.favorite_category === "岗位") {
      row = <RecruitmentRow {...item} fairId={"0"} />;
    } else if (item.favorite_category === "校园招聘") {
      row = <RecruitRow {...item} />;
    } else if (item.favorite_category === "推荐信息") {
      row = <RecommendRow {...item} />;
    }
    return row;
  };

  const handleLogIn = async () => {
    location.href = "#/登录?id=1";
  };

  return (
    <>
      {auth === 0 ? (
        <div className="container-fluid">
          <div className="chat-login">
            <h6>登录后可以查看收藏</h6>
            <button
              type="button"
              style={{ width: "25%" }}
              className="btn btn-block mx-auto rounded-pill button-background text-white font-weight"
              onClick={handleLogIn}
            >
              登&nbsp;录
            </button>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ fontSize: 14 }}>
          {list.length === 0 ? (
            <div className="chat-login">
              <h6>您还没有收藏任何信息</h6>
            </div>
          ) : (
            <div>
              <div className="mt-2" />
              {list &&
                progress === 4 &&
                list.map((item) => (
                  <div className="card border-0 p-3 user-radius mb-2 mt-2" key={item.id}>
                    {dateRow(item)}
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
      <Navbar category="我的" />
    </>
  );
};

export default Favorite;
